import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { Button, Container, Stack, Typography } from "@mui/material";
import { useState } from "react";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useClientContext from "../../../context/useClientContext";
import ApplicationStatusTag from "../../common/ApplicationStatusTag";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import InvestorPortalLinks from "../investor-portal/general/InvestorPortalLinks";
import InvestorPortalImpersonateButton from "../investor-portal/InvestorPortalImpersonateButton";
import InvestorPortalStyleDialog from "../investor-portal/style/InvestorPortalStyleDialog";
import PortfolioPortalPagesSection from "./PortfolioPortalPagesSection";

const PortfolioPortalPage = () => {
  usePageTitle("Portfolio Portal");

  const { portfolioMonitoringApp } = useClientContext();

  const [isStyleDialogOpen, setIsStyleDialogOpen] = useState(false);

  return (
    <>
      <GeneralPageHeader title="Portfolio Portal">
        <InvestorPortalImpersonateButton variant="outlined" color="secondary" params={{ target: "DataCollection" }} />
        <Button
          variant="contained"
          startIcon={<SettingsIcon />}
          onClick={() => setIsStyleDialogOpen(true)}
          disabled={!portfolioMonitoringApp}
        >
          Configure Style
        </Button>
      </GeneralPageHeader>
      {isStyleDialogOpen && portfolioMonitoringApp && (
        <InvestorPortalStyleDialog impersonationTarget="DataCollection" onClose={() => setIsStyleDialogOpen(false)} />
      )}
      <Container maxWidth="md" disableGutters>
        <Stack spacing={3} sx={{ py: 2.5 }}>
          <Typography variant="subtitle1">Portal Links</Typography>

          <Stack direction="row" spacing={1}>
            <Typography color="secondary" sx={{ width: "3.5rem" }}>
              Status
            </Typography>
            <ApplicationStatusTag
              appStatus={portfolioMonitoringApp?.dataCollection?.enabled ? "Published" : "NotConfigured"}
            />
          </Stack>

          <InvestorPortalLinks />

          <PortfolioPortalPagesSection />
        </Stack>
      </Container>
    </>
  );
};

export default PortfolioPortalPage;
